module.exports = __webpack_public_path__ + "img/Ko-fi_Logo_RGB.ad70f9d7.png";